<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="MaintainceInfoForm">
        <div class="my-section-box__headline">{{ 'common.smartire_maintaince_per_Vechile' | cxTranslate }}
        </div>
        <div class="my-section-box fleetInfo" id="maintainceInfo">
          <div class="my-section-box-inner fleet-info-block">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <label class="form-label" for="costOfDiesel">{{
                  'common.text_smartire_cost_fuel' |
                cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-sm-6 pr-0">
                    <input class="fleet-info-input" type="text" formControlName="costOfDiesel" />
                    @if (form.costOfDiesel.invalid && (form.costOfDiesel.dirty || form.costOfDiesel.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-6 pl-1 EnduTooltip">
                    USD/Gallon
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <label class="form-label" for="costPerTire">{{
                  'common.text_smartire_cost_per_tire' |
                cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-sm-6 pr-0">
                    <input class="fleet-info-input" type="text" formControlName="costPerTire" />
                    @if (form.costPerTire.invalid && (form.costPerTire.dirty || form.costPerTire.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-6 pl-1 EnduTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <label class="form-label" for="serviceCostUSD">{{
                  'common.text_smartire_service_cost' |
                  cxTranslate }}
                  <mat-dialog-actions class="EnduTooltip">
                    <span
                      (click)="endasureService.openTootlip( 'common.smartire_tooltip_tittle', 'common.smartire_tooltip_content' )"
                      class="btn-link">
                      <img src="/icons/question_dark_kb.svg" style="width:20px"
                        alt="Smart tire Maintance">
                      </span>
                    </mat-dialog-actions></label>
                    <div class="row">
                      <div class="col-3 row">
                        <div class="col-8 col-sm-4 pr-0">
                          <input type="number" class="fleet-info-input"
                            formControlName="serviceCostUSD" />
                          </div>
                          <div class="col-4 col-sm-8 EnduTooltip">
                            USD at
                          </div>
                          @if (form.serviceCostUSD.invalid && (form.serviceCostUSD.dirty || form.serviceCostUSD.touched)) {
                            <span class="text-danger-show"
                              >
                            {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                          }
                        </div>
                        <div class="col-3 row">
                          <div class="col-8 col-sm-4 pr-0 pl-0">
                            <input type="number" class="fleet-info-input"
                              formControlName="serviceCostMins" />
                            </div>
                            <div class="col-4 col-sm-8 EnduTooltip">
                              {{ 'common.text_smartire_minutes_per_tire' | cxTranslate }}
                            </div>
                            @if (form.serviceCostMins.invalid && (form.serviceCostMins.dirty || form.serviceCostMins.touched)) {
                              <span class="text-danger-show"
                                >
                              {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                            }
                          </div>
                          <div class="col-3 row">
                            <div class="col-8 col-sm-4 pr-0 pl-0">
                              <input type="number" class="fleet-info-input"
                                formControlName="serviceCostHours" />
                              </div>
                              <div class="col-4 col-sm-8 EnduTooltip">
                                {{ 'common.text_smartire_usd_per_hour' | cxTranslate }}
                              </div>
                              @if (form.serviceCostHours.invalid && (form.serviceCostHours.dirty || form.serviceCostHours.touched)) {
                                <span class="text-danger-show"
                                  >
                                {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                          <label class="form-label" for="costPerDowntime">{{
                            'common.text_smartire_cost_downtime' |
                          cxTranslate }}</label>
                          <div class="col-12 px-0 row">
                            <div class="col-8 col-sm-6 pr-0">
                              <input class="fleet-info-input" type="text" formControlName="costPerDowntime" />
                              @if (form.costPerDowntime.invalid && (form.costPerDowntime.dirty || form.costPerDowntime.touched)) {
                                <span class="text-danger-show"
                                  >
                                {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                              }
                            </div>
                            <div class="col-4 col-sm-6 pl-1 EnduTooltip">
                              {{ 'common.text_smartire_usd' | cxTranslate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="airdisk-button-block">
                        <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn col-6"
                          (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                          alt="Back">
                        {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                        <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn col-6"
                          (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                          <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                        </div>
                      </div>
                    </div>
                  </form>
                }
              </div>
            </div>